import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { DataModelBuilderViewModel } from "../datamodel/dataModelBuilder/dataModelBuilder-viewModel";
import { FormBuilderViewModel, IFormBuilderPart } from "./formBuilder/formBuilder-viewModel";
import { FormBuilderWindowViewModel } from "./formBuilderWindow-viewModel"
import { ViewModelBuilderViewModel } from "./viewModelBuilder/viewModelBuilder-viewModel";

export class FormBuilderWindowView extends View<FormBuilderWindowViewModel>{
    GetViewUniqueId(): string {
        return "V-D4257E2C-0710-41B6-85CB-C14E09902879"
    }
    loadHtml(): string {
        let element = require('./formBuilderWindow.html').default;
        let style = require('./formBuilderWindow.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set formBuilder(v: FormBuilderViewModel) { this._formBuilder = v; } public get formBuilder(): FormBuilderViewModel { return this._formBuilder;} private _formBuilder: FormBuilderViewModel;
    public set dataModelBuilder(v: DataModelBuilderViewModel) { this._dataModelBuilder = v; } public get dataModelBuilder(): DataModelBuilderViewModel { return this._dataModelBuilder;} private _dataModelBuilder: DataModelBuilderViewModel;
    public set parts(v: ObservableArray<IFormBuilderPart>) { this._parts = v; } public get parts(): ObservableArray<IFormBuilderPart> { return this._parts;} private _parts: ObservableArray<IFormBuilderPart>;
    public set selectedPart(v: IFormBuilderPart) { this._selectedPart = v; } public get selectedPart(): IFormBuilderPart { return this._selectedPart;} private _selectedPart: IFormBuilderPart;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

}
